module.exports = __webpack_public_path__ + "img/loading.6a2f1499.gif";